import { applyLottieThemeToJson, LottieResolvedThemeColors } from './apply-lottie-theme-to-json';
import { parseCssColorToLottieRgba } from './parse-css-color-to-lottie';

/** Hex/CSS → RGB Lottie (0–1); null si vacío, inválido o alpha ≈ 0. */
export function cssColorToLottieRgb(css: string | null | undefined): [number, number, number] | null {
	if (css == null) {
		return null;
	}
	const parsed = parseCssColorToLottieRgba(String(css));
	if (!parsed || parsed[3] < 0.01) {
		return null;
	}
	return [parsed[0], parsed[1], parsed[2]];
}

export function buildLottieThemeFromCss(colors: {
	border?: string | null;
	iconBorder?: string | null;
	background?: string | null;
	secondaryBorder?: string | null;
}): LottieResolvedThemeColors {
	return {
		borderRgb: cssColorToLottieRgb(colors.border),
		iconBorderRgb: cssColorToLottieRgb(colors.iconBorder),
		backgroundRgb: cssColorToLottieRgb(colors.background),
		secondaryBorderRgb: cssColorToLottieRgb(colors.secondaryBorder),
	};
}

export function themeLottieAnimationData(
	data: unknown,
	colors: {
		border?: string | null;
		iconBorder?: string | null;
		background?: string | null;
		secondaryBorder?: string | null;
	},
): unknown {
	const clone =
		typeof structuredClone === 'function'
			? structuredClone(data)
			: (JSON.parse(JSON.stringify(data)) as unknown);
	applyLottieThemeToJson(clone, buildLottieThemeFromCss(colors));
	return clone;
}
